import { Link } from "react-router-dom";

import { TrophyIcon } from "lucide-react";

import { formatDateAt } from "simplydo/core/dates";
import { Icon } from "simplydo/react/ui/icon";

import { useAppSelector } from "store";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIconCircle,
  FeedItemMessage,
} from "./FeedItemUI";

type AchievementFeedItemProps = { item: FeedItemOfType<"achievement"> };

const AchievementFeedItem = ({ item }: AchievementFeedItemProps) => {
  const user = useAppSelector((state) => state.user);

  return (
    <FeedItem>
      <FeedItemIconCircle>
        <Icon icon={TrophyIcon} color="primary" />
      </FeedItemIconCircle>
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={user} compact="very" />
          </b>{" "}
          <span>
            earned <Link to="/achievements">{item.name}</Link>.
          </span>
        </FeedItemMessage>
        {item.description ? (
          <div style={{ color: "#5d5d5d" }}>{item.description}</div>
        ) : null}
        <FeedItemDate>{formatDateAt(item.achievedAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default AchievementFeedItem;
